import request from "@/utils/request";
const scope = '';

// 官方动态分页数据
export function clientGetInformationList(query) {
  return request({
    url: scope + "/exueyun-client-consumer/clientSystemInformation/clientGetInformationList",
    method: "post",
    data: query
  });
}

// 官方动态详情
export function clientGetInformationById(query) {
    return request({
      url: scope + "/exueyun-client-consumer/clientSystemInformation/clientGetInformationById",
      method: "post",
      data: query
    });
  }

// 官方动态点赞
export function clientLikeInformation(query) {
    return request({
      url: scope + "/exueyun-client-consumer/clientSystemInformation/clientLikeInformation",
      method: "post",
      data: query
    });
  }

// 官方动态取消点赞
export function clientCancelLikeInformation(query) {
    return request({
      url: scope + "/exueyun-client-consumer/clientSystemInformation/clientCancelLikeInformation",
      method: "post",
      data: query
    });
  }

  // 学校通知详情
export function getSchoolNoticeById(query) {
    return request({
      url: scope + "/exueyun-client-consumer/schoolNotice/querySchoolNoticeById",
      method: "post",
      data: query
    });
  }